import { AgResourceLanguage } from '../types';
import { checkout as EnUsCheckout } from '../en-us/checkout';

export const checkout: AgResourceLanguage['checkout'] = {
  ...EnUsCheckout,
  paymentExpress: {
    title: 'Pago Rápido',
    caption: 'o continúa abajo para pagar con tarjeta de crédito'
  },
  summaryBlock: {
    title: {
      desktopView: 'Resumen del Pedido',
      mobileView: 'Resumen'
    },
    productsOrderSummary: {
      showProduct: 'Mostrar Resumen del Pedido',
      label: 'Productos',
      hideProduct: 'Ocultar Resumen del Pedido',
      gift: 'Regalo Gratis',
      giftPrice: 'Gratis',
      shipsEvery: 'Enviado cada',
      shipsOneTime: 'Enviado una vez',
      frequencyUnit: 'días',
      welcomeKitRemoved: `
        <p>
          ¡Bienvenido de nuevo!
          <br>Lo sentimos, nuestro Kit de Bienvenida es solo para nuevos clientes. ¿Necesitas un reemplazo? Ponte en contacto con nuestro equipo de Atención al Cliente.
        </p>
      `
    }
  },
  paymentFields: {
    paymentTitle: 'Pago',
    paymentReviewTitle: 'Revisar Pago',
    paymentReviewButton: 'Editar',
    paymentPageContinueButton: 'Revisar Pedido',
    creditCardLabel: 'Tarjeta de Crédito',
    creditCardReviewText: '{{brand}} terminada en {{last4}}',
    creditCardCustomError: 'Los detalles de tu tarjeta están incompletos.',
    sepaLabel: 'Débito Directo SEPA',
    sepaReviewText: 'SEPA terminada en {{name}}',
    sepaDisclaimer: `
      Autorizo a Athletic Greens (EU) Limited a realizar cobros de mi cuenta mediante débito directo.
      Para suscripciones, esta autorización se aplica a pagos recurrentes.
      Instruyo a mi banco a aceptar débitos directos de Athletic Greens (EU) Limited.
      Acepto que el plazo de notificación previa del débito directo se reduzca a un día.
      Nota: puedo solicitar un reembolso dentro de las 8 semanas a partir de la fecha de débito.
      Se aplican las condiciones acordadas con mi banco.
    `,
    paymentPageWalletsFields: {
      deleteButton: 'Eliminar',
      label: 'Métodos de Pago'
    },
    walletsTotalLabel: 'Total'
  },
  shippingFields: {
    subTitle: 'Información de Envío',
    caption: 'Tu pedido será enviado dentro de 3-5 días hábiles.',
    email: 'Correo Electrónico',
    countryRegion: 'País/región',
    firstName: 'Nombre',
    lastName: 'Apellido',
    addressLine1: 'Dirección',
    addressLine2: 'Apartamento, Suite, Etc.',
    city: 'Ciudad',
    state: 'Provincia',
    zipCode: 'Código Postal',
    phone: 'Teléfono',
    pccc: 'Número PCCC/Pasaporte',
    isCreateAccount: 'Mantente comprometido con consejos, inspiración y comunidad.',
    submitButtonText: 'Continuar al Pago',
    freeSubmitButtonText: 'Revisar Pedido',
    reviewTitle: 'Envío',
    reviewButton: 'Editar',
    subscribeOnSms: `
      <p>
        <strong>Envíame un SMS cuando mi AG1 sea enviado y sobre contenido exclusivo de salud y ciencia.</strong> 
        Acepto recibir mensajes de marketing por SMS de DrinkAG1 al número proporcionado.
        El consentimiento no es una condición para la compra. Se pueden aplicar tarifas de mensajes y datos. Responde con HELP o STOP para cancelar. 
        Consulta nuestros <a href="https://drinkag1.com/text-message-terms/" target="_blank" rel="noopener">Términos de Mensajes SMS</a>, 
        <a href="https://drinkag1.com/privacy/" target="_blank" rel="noopener">Política de Privacidad</a> &amp; 
        <a href="https://drinkag1.com/terms-and-conditions/" target="_blank" rel="noopener">Términos y Condiciones</a>.
      </p>
    `
  },
  placeOrderFields: {
    continueButton: 'Realizar Pedido',
    otpCaption: `
      <p>Al realizar este pedido, aceptas los 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Términos y Condiciones</a> 
        y la&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Política de Privacidad</a>.
      </p>
    `,
    subscriptionCaption: `
      <p>
        Al realizar este pedido, aceptas los 
        <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Términos y Condiciones</a> 
        y la&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Política de Privacidad</a>.
        <br><br>
      </p>
      <p>
        Estás comprando una suscripción continua. Autorizas a Athletic Greens a cargar el método de pago registrado cada 30 días al precio vigente en ese momento. Tu suscripción se renovará automáticamente cada 30 días hasta que la canceles. Puedes cancelar en cualquier momento antes de tu próximo envío visitando tu cuenta o enviando un correo electrónico a <a href="mailto:support@drinkag1.com">support@drinkag1.com</a>.
      </p>
    `
  },
  thanksFields: {
    accountPasswordLabel: 'Contraseña',
    minLength: 'Mínimo 8 caracteres',
    maxLength: 'La contraseña es demasiado larga (máximo 40 caracteres)',
    whitespace: 'La contraseña no puede comenzar ni terminar con espacios',
    uppercase: '1 mayúscula',
    lowercase: '1 minúscula',
    number: '1 número',
    accountButtonLabelCreate: 'Crear una Cuenta',
    accountButtonLabelVisit: 'Visitar Mi Cuenta',
    accountButtonLabelError: 'Visitar Mi Cuenta',
    successMessage: `
      <h1>¡Bienvenido a la Nutrición Fundamental, {{customerFirstName}}!</h1>
      <p>Confirmación enviada a: {{customerEmail}}</p>
    `,
    errorMessage: `
      <h1>Bienvenido a AG1</h1>
      <p>Inicia sesión para gestionar tu cuenta, rastrear pedidos y comprar productos exclusivos.</p>
    `,
    orderDetails: `
      <p><strong>Número de Pedido:</strong> #{{orderId}}</p>
      <p><strong>Entregado a:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    accountTitleNotCreated: `
      <h2>Crear una Cuenta</h2>
      <p>Revisa el estado de los pedidos, sigue los envíos y más.</p>
    `,
    accountTitleCreated: `
      <h2>Crear una Cuenta</h2>
      <p>Revisa el estado de los pedidos, sigue los envíos y más.</p>
    `
  },
  unifiedOrderReview: {
    backButton: 'Regresar a la Tienda',
    shippingFieldsTitle: 'Información de Envío',
    shippingMethodSubTitle: 'Método de Envío',
    frequencySubTitle: 'Frecuencia de Envío',
    frequencyText: 'Cada {{frequency}}',
    frequencyUnit: 'día',
    paymentTitle: 'Pago',
    paymentSubTitle: 'Método de Pago',
    billingAddressSubTitle: 'Dirección de Facturación',
    billingAddressDescription: 'Igual que la dirección de envío',
    placeOrderButton: 'Realizar Pedido',
    commonCaption: `
    <p>
      Estás comprando una suscripción continua. Autorizas a Athletic Greens a cargar el método de pago registrado cada {{order_frequency_days}} días al precio vigente en ese momento.
      Tu suscripción se renovará automáticamente cada {{order_frequency_days}} días hasta que la canceles.
      Puedes cancelar en cualquier momento antes de tu próximo envío visitando tu cuenta o enviando un correo electrónico a <a href="mailto:support@drinkag1.com">support@drinkag1.com</a>.
    </p>
  `,
    giftTitle: 'Enviar como regalo',
    giftRecipientEmailLabel: 'Correo Electrónico del Destinatario*',
    giftMessageLabel: 'Mensaje de Regalo',
    shippingAddressTitle: 'Dirección de Envío',
    shippingAddressText: 'Añade el nombre y la dirección del destinatario'
  },
  thanksFieldsMembers: {
    successMessage: `
      <h1>¡Hurra, tu pedido ha sido realizado!</h1>
      <p>Confirmación enviada a: {{customerEmail}}</p>
    `,
    successMessageGift: `
      <h1>¡Hurra, tu pedido de regalo ha sido confirmado!</h1>
      <p>Un correo de confirmación ha sido enviado a: {{customerEmail}} y {{giftRecipientEmail}}</p>
    `,
    successMessageFreeGift: `
      <h1>¡Gracias por compartir!</h1>
      <p>El correo de confirmación ha sido enviado a: {{customerEmail}} y {{giftRecipientEmail}}</p>
    `,
    orderDetails: `
      <p><strong>Número de Pedido:</strong> #{{orderId}}</p>
      <p><strong>Entregado a:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
    `,
    giftOrderDetails: `
      <p><strong>Número de Pedido:</strong> #{{orderId}}</p>
      <p><strong>Tipo de Pedido:</strong> Compartir Paquetes Gratis</p>
      <p><strong>Total:</strong> {{total}}</p>
      <p><strong>Entregado a:</strong> {{customerName}}</p>
      <p>{{address}}</p></div>
      <p>{{email}}</p></div>
    `,
    giftOrderDetailsPaid: `
    <p><strong>Número de Pedido:</strong> #{{orderId}}</p>
    <p><strong>Entregado a:</strong> {{customerName}}</p>
    <p><strong>Correo Electrónico:</strong> {{email}}</p>
    <p>{{address}}</p></div>
    `,
    viewOrderButtonLabel: 'Ver Detalles del Pedido',
    shareMorePacksButtonLabel: 'Compartir Más Paquetes',
    giftMessageTitle: 'Mensaje de Regalo:'
  },
  // Si Sanity no funciona
  header: {
    title: 'PAGAR',
    editOrder: 'Editar Pedido'
  },
  footer: {
    links: [
      { url: 'https://drinkag1.com/privacy', target: true, text: 'Política de Privacidad' },
      {
        url: 'https://drinkag1.com/terms-and-conditions',
        target: true,
        text: 'Términos y Condiciones'
      }
    ]
  }
};
